module.exports = __webpack_public_path__ + "img/chargingpoint-charging-hub-rejected.c87e292e.png";